import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/issues';

export class IssueService extends RestServiceConnection {


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE INCIDENCIAS
     * @EN GETS THE LIST OF ISSUES
     */
    // -------------------------------------------------------------------------------------------------------------
    listIssues = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA LOS ESTDOS DE INCIDENCIAS
     * @EN GETS THE LIST OF ISSUES STATES
     */
    // -------------------------------------------------------------------------------------------------------------
    listStatusIssues = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-status',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UNA INCIDENCIA POR SU ID
     * @EN GETS A ISSUE BY ITS ID
     * 
     * @param issueId
     */
    // -------------------------------------------------------------------------------------------------------------
    getIssueById = async (issueId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { 
                id: issueId
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE EL NÚMERO TOTAL DE INCIDENCIAS
     * @EN GETS THE TOTAL NUMBER OF ISSUES
     */
    // -------------------------------------------------------------------------------------------------------------
    getTotalIssues = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get-issues-total-by-state',
            data: filters,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UNA INCIDENCIA
     * @EN CREATES A ISSUES
     * 
     * @param issue
     */
    // -------------------------------------------------------------------------------------------------------------
    createIssues = async (issue: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: issue,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES IMPORTA INCIDENCIAS DESDE EXCEL
     * @EN IMPORTS ISSUES FROM EXCEL
     *
     * @param formData
     */
    // -------------------------------------------------------------------------------------------------------------
    importIssues = async (formData: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/import',
            data: formData,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ACTUALIZA UNA INCIDENCIA
     * @EN UPDATES A ISSUE
     * 
     * @param park
     */
    // -------------------------------------------------------------------------------------------------------------
    editIssue = async (issue: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: issue,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UNA INCIDENCIA
     * @EN DELETES A ISSUE
     * 
     * @param issueId
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteIssue = async (issueId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { 
                id: issueId
             },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UNA INCIDENCIA
     * @EN DELETES A ISSUE
     * 
     * @param issueId
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiIssues = async (issuesIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { 
                issuesIds: issuesIds
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CAMBIA EL ESTADO DE UNA INCIDENCIA
     * @EN CHANGES THE STATE OF A ISSUE
     * 
     * @param issueId
     * @param statusId
     */
    // -------------------------------------------------------------------------------------------------------------
    changeStatusIssue = async (issueId: string, statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/change-status',
            data: { 
                id: issueId,
                statusId: statusId
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA LOS ESTDOS DE INCIDENCIAS
     * @EN GETS THE LIST OF ISSUES STATES
     */
    // -------------------------------------------------------------------------------------------------------------
    listForSelectStatus = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-select-status',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    
    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ACTUALIZA LA LOCALIZACIÓN DEL CADAVER DE UNA INCIDENCIA
     * @EN UPDATES THE LOCATION OF THE CORPSE OF A ISSUE
     * 
     * @param issueId
     * @param base64
     */
    // -------------------------------------------------------------------------------------------------------------
    updateIssueLocationCorpse = async (issueId: string, base64: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/add-coordinates-image',
            data: { 
                id: issueId,
                base64: base64
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES EXPORTA UNA INCIDENCIA A EL FORMATO DE LA JUNTA DE ANDALUCÍA
     * @EN EXPORTS A ISSUE TO THE FORMAT OF THE ANDALUSIAN BOARD
     */
    // -------------------------------------------------------------------------------------------------------------
    exportToJDA = async (id?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/export-to-junta',
            data: {
                id: id
            },
            responseType: 'blob',
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES VALIDA VARIAS INCIDENCIAS
     * @EN VALIDATES MULTIPLE ISSUES
     * 
     * @param issuesIds
     */
    // -------------------------------------------------------------------------------------------------------------
    validateSelectedIssues = async (issuesIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/validate-multiple',
            data: { ids : issuesIds },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
}
